import {FilledClockIcon, Grid, Typography, UnstableCard as Paper} from '@yandex-delivery/blocks'
import React from 'react'

import {Body, Header, Tabs} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import {deliveryTypes, OfferDeliveryType} from './consts'
import {DeliveryIntervals} from './DeliveryIntervals/DeliveryIntervals'
import {useOffers} from './hooks'
import {OfferList} from './OfferList/OfferList'
import {OrderTime} from './OrderTime/OrderTime'
import type {Props} from './types'

export function Offers(props: Props): React.ReactElement<Props> {
  const {name} = props
  const {verticalDueSettings, isOrderTimeVisible, isDeliveryIntervalVisible, handleDueSelect, offersBody, updateKey} =
    useOffers(name)

  return (
    <Paper radius="L">
      <Grid size="m" container>
        <Grid xs={12} item>
          {/* заголовок с табами через Body рисуется лучше */}
          <Body
            tail={
              verticalDueSettings ? (
                <Tabs
                  defaultValue={OfferDeliveryType.Now}
                  items={deliveryTypes}
                  name={`${name}.deliveryType`}
                  onChange={handleDueSelect}
                />
              ) : (
                <React.Fragment />
              )
            }
          >
            <Header lead={<FilledClockIcon />}>
              <Typography group="tight" thickness="medium" variant="title4">
                {i18n('cargo.create.when.title', 'Когда')}
              </Typography>
            </Header>
          </Body>
        </Grid>
        {verticalDueSettings && isOrderTimeVisible && (
          <Grid xs={12} item>
            <Body
              lead={
                <Typography group="tight" pt="m" thickness="medium" variant="body2">
                  {i18n('cargo.create.offers.due.start', 'Когда начать')}
                </Typography>
              }
              tail={<OrderTime dueSettings={verticalDueSettings} name={name} />}
            />
          </Grid>
        )}
        <Grid xs={12} item>
          <Body
            tail={
              isDeliveryIntervalVisible ? (
                <DeliveryIntervals name={name} />
              ) : (
                <OfferList key={updateKey} body={offersBody} name={`${name}.offer`} />
              )
            }
          />
        </Grid>
      </Grid>
    </Paper>
  )
}
